module.exports = __webpack_public_path__ + "static/media/img.4099dc29.webp";